module.exports = __webpack_public_path__ + "img/18233211002426.58a0f32e.png";